import { render } from "./trash-scan.vue?vue&type=template&id=6e18259a"
import script from "./trash-scan.vue?vue&type=script&lang=js"
export * from "./trash-scan.vue?vue&type=script&lang=js"

import "./trash-scan.vue?vue&type=style&index=0&id=6e18259a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__